import { createAction, props } from '@ngrx/store';
import { Pagination } from '@shared/models/pagination.model';

import { ClaimListContent, ClaimListSearchCriteria, ClaimViewResponse } from '../model/claim-model';

export const ClaimAction = {
  claimListRequest: createAction('[Claim] Claim List Request', props<{ payload: ClaimListSearchCriteria }>()),
  claimListResponse: createAction('[Claim] Claim List Response', props<{ response: Pagination<ClaimListContent> }>()),
  claimViewRequest: createAction('[Claim] Claim View Request', props<{ payload: { docNo: string } }>()),
  claimViewResponse: createAction('[Claim] Claim View Response', props<{ response: ClaimViewResponse }>()),
  resetClaimView: createAction('[Claim] Reset Claim View'),
  resetClaimList: createAction('[Claim] Reset Claim List')
};
